var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88396 2C5.08485 2 2.00016 5.08469 2.00016 8.8838C2.00016 12.6829 5.08485 15.7676 8.88396 15.7676C12.6831 15.7676 15.7678 12.6829 15.7678 8.8838C15.7678 5.08469 12.6831 2 8.88396 2ZM8.88396 3.11629C12.0669 3.11629 14.6515 5.70088 14.6515 8.8838C14.6515 12.0667 12.0669 14.6513 8.88396 14.6513C5.70104 14.6513 3.11645 12.0667 3.11645 8.8838C3.11645 5.70088 5.70104 3.11629 8.88396 3.11629Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8364 17.0476L13.7508 12.9612C13.5327 12.7432 13.1793 12.7432 12.9612 12.9612C12.7432 13.1793 12.7432 13.5328 12.9612 13.7508L17.0476 17.8365C17.2649 18.0545 17.6191 18.0545 17.8364 17.8365C18.0545 17.6192 18.0545 17.2649 17.8364 17.0476Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search1.c62237da2a260b6a2394db171bf892e7.svg";
export { ForwardRef as ReactComponent };